import { render } from "./PersonalItems.vue?vue&type=template&id=372b2b49"
import script from "./PersonalItems.vue?vue&type=script&lang=js"
export * from "./PersonalItems.vue?vue&type=script&lang=js"

import exportComponent from "/home/marina-brunello/lifetime/hitting-the-target-australia/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__